import useTabState from '../hooks/useTabState';
import PageLayout from '../components/ui/PageLayout';
import TabBar from '../components/ui/TabBar';
import Trends from './Trends';
import Correlations from './Correlations';
import DecisionHistory from './DecisionHistory';
import AIQuality from './AIQuality';

const TABS = ['Trends', 'Correlations', 'Decision History', 'AI Quality'] as const;
type Tab = typeof TABS[number];

export default function Analytics() {
  const [activeTab, setActiveTab] = useTabState<Tab>('tab', TABS, 'Trends');

  return (
    <PageLayout title="Analytics" subtitle="Trend analysis, correlations, and quality metrics">
      <TabBar
        tabs={TABS.map(t => ({ key: t, label: t }))}
        active={activeTab}
        onChange={v => setActiveTab(v as Tab)}
      />
      {activeTab === 'Trends' && <Trends />}
      {activeTab === 'Correlations' && <Correlations />}
      {activeTab === 'Decision History' && <DecisionHistory />}
      {activeTab === 'AI Quality' && <AIQuality />}
    </PageLayout>
  );
}
